import { StackNavigationProp } from '@react-navigation/stack'
import * as React from 'react'
import { StyleSheet, FlatList } from 'react-native'
import { Card, Paragraph } from 'react-native-paper'
import Screen from '../../components/Screen'

import DownloadButton from '../../components/DownloadButton'

import { Text, useThemeColor } from '../../components/Themed'
import Colors from '../../constants/Colors'
import { meditations, MeditationItem } from '../../data/meditations'
import { HomeParamList } from '../../types'
import { useAppSelector } from '../../hooks'
import { selectFavourites } from '../../redux/selectors'

interface Props {
  navigation: StackNavigationProp<HomeParamList, 'HomeScreen'>
}

export default function Home({ navigation }: Props) {
  const textColor = useThemeColor({}, 'text')

  const favourites = useAppSelector(selectFavourites)

  const renderCard = ({ item }: MeditationItem) => {
    return (
      <Card
        style={styles.card}
        onPress={() =>
          {
            if (item.subtitle === "Finger Induced Lucid Dream")
            {
              navigation.navigate('FieldScreen', {
                id: item.id,
              })
            }
            else if (item.subtitle === "Dream Induced Lucid Dream")
            {
              navigation.navigate('DildScreen', {
                id: item.id,
              })
            }
            else 
            {
              navigation.navigate('PlayScreen', {
                id: item.id,
            })
            }
          }
        }
      >
        <Card.Cover style={styles.cardImage} source={item.image} />
        <Card.Title
          titleStyle={[styles.cardTitle]}
          subtitleStyle={styles.cardSubtitle}
          title={item.title}
          //subtitle={item.subtitle}
        />
        <Card.Content style={styles.cardContent}>
          <Paragraph style={styles.cardParagraph}>{item.time} minutes</Paragraph>
          {item.subtitle !== "Dream Induced Lucid Dream" ?
          <DownloadButton id={item.id} style={styles.downloadButton} /> :  <Text />
          }
        </Card.Content>
      </Card>
    )
  }

  return (
    <Screen scroll>
    {favourites.length > 0 && (
      <>
        <Text style={styles.title}>Favorites</Text>
        <FlatList
          style={styles.cards}
          horizontal
          showsHorizontalScrollIndicator={false}
          data={favourites}
          renderItem={renderCard}
          keyExtractor={({ id }) => id}
        />
      </>
    )}
    <Text style={styles.title}>Lucidity Exercises</Text>
    <FlatList
      style={styles.cards}
      horizontal
      showsHorizontalScrollIndicator={false}
      data={meditations.exercises}
      renderItem={renderCard}
      keyExtractor={({ id }) => id}
    />
    <Text style={styles.title}>Mindfulness Exercises</Text>
    <FlatList
      style={styles.cards}
      horizontal
      showsHorizontalScrollIndicator={false}
      data={meditations.mindfulness}
      renderItem={renderCard}
      keyExtractor={({ id }) => id}
    />
    </Screen>
  )
}

const styles = StyleSheet.create({
  card: {
    width: 250,
    marginRight: 10,
  },
  cardTitle: {
    color: Colors.light.gray100,
    fontSize: 16,
  },
  cardImage: {
    height: 135,
  },
  popularImage: {
    height: 250,
  },
  cardContent: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  cardSubtitle: {
    color: Colors.light.gray800,
    fontSize: 14,
  },
  cardParagraph: {
    color: Colors.light.primary,
    fontWeight: '600',
  },
  downloadButton: {
    position: 'relative',
    top: -6,
  },
  cards: {
    marginBottom: 30,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 19,
  },
})
